// Copyright (c) 2019 Comsearch, Inc., All rights reserved

// returns an array of path ids for the given groupedFrequencyPlan
// filtered against the list of currently visible path ids

const getVisibleGroupedPathIds = (groupedFrequencyPlan, visiblePathIds) => (
  groupedFrequencyPlan.get('paths').reduce((a, d) => {
    if (visiblePathIds.includes(d.get('pathId'))) {
      a.push(d.get('pathId'))
    }
    return a
  }, [])
)

export default getVisibleGroupedPathIds
